import { AllocationBase } from "../../accounting/abstract/allocation-base.model";

export class ChequeAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'ChequeAllocation';

}
